'use client';

import { IconSortAscendingFilled } from '@zillow/constellation-icons/react/filled/icon-sort-ascending-filled';
import { IconSortDescendingFilled } from '@zillow/constellation-icons/react/filled/icon-sort-descending-filled';
import { IconSortFilled } from '@zillow/constellation-icons/react/filled/icon-sort-filled';
import { forwardRef, useContext } from 'react';

import { Icon } from '../icon/icon';
import { TableHeaderCellContext } from './context/table-header-cell.context';
import { TableRootContext } from './context/table-root.context';
import { tableSortIconRecipe } from './styles/table-sort-icon.styles';
import type { TableSortIconPropsInterface } from './types/table-sort-icon.types';

const ICONS = {
  ascending: <IconSortAscendingFilled />,
  descending: <IconSortDescendingFilled />,
  none: <IconSortFilled />,
} as const;

/**
 * @since 8.41.0
 */
export const TableSortIcon = forwardRef<SVGSVGElement, TableSortIconPropsInterface>(
  (props: TableSortIconPropsInterface, forwardedRef) => {
    const { css: cssProp, ...rest } = props;

    const { sortDirection } = useContext(TableRootContext);
    const { sorted } = useContext(TableHeaderCellContext);

    return (
      <Icon
        ref={forwardedRef}
        data-c11n-component="Table.SortIcon"
        data-c11n-version={__C11N_VERSION__}
        css={{
          ...tableSortIconRecipe.raw({ selected: !!sorted }),
          ...cssProp,
        }}
        render={ICONS[sorted ? sortDirection! : 'none']}
        {...rest}
      />
    );
  },
);

TableSortIcon.displayName = 'Table.SortIcon';
